import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DatePicker } from "@mui/x-date-pickers";
import { useToastContext } from "components/alert/ToastContext";
import MultiSeletor from "components/multiSeletor/MultiSeletor";
import dayjs from "dayjs";
import saveAs from 'file-saver';
import Setor from "model/administracao/cadastro/Setor";
import ItemClasseAuditoria from "model/auditoria5s/auditoria/ItemClasseAuditoria";
import PlanoAuditoria from "model/auditoria5s/planoDeAuditoria/PlanoAuditoria";
import { ChartMultiBarModel } from "model/chart/ChartMultiBarModel";
import { ChartPieModel } from "model/chart/ChartPieModel";
import Pageable from "model/page/Pageable";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable, DataTableExpandedRows, DataTableOperatorFilterMetaData, DataTableStateEvent, DataTableValueArray } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { SplitButton } from "primereact/splitbutton";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import AuditoriaDashboardService, { AuditoriaDashboardFilters } from "service/auditoria5s/AuditoriaDashboardService";
import AuditoriaService from "service/auditoria5s/AuditoriaService";
import AuditoriaNaoConformidadeChartBar from "./charts/AuditoriaNaoConformidadeChartBar";
import AuditoriaNaoConformidadeChartPie from "./charts/AuditoriaNaoConformidadeChartPie";
import { Label } from "components/input/Label";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";

const auditoriaService = new AuditoriaService();
const auditoriaDashboardService = new AuditoriaDashboardService();
export default function AuditoriaNaoConformidadeDashboard() {

    const [chartNaoConformidadePizza, setChartNaoConformidadePizza] = useState<ChartPieModel>({ title: "", pieces: [] });
    const [chartNaoConformidadeBarras, setChartNaoConformidadeBarras] = useState<ChartMultiBarModel>({ nameX: "", nameY: "", title: "", multiBars: [] });
    const [filtrando, setFiltrando] = useState<boolean>(false);
    const [rows, setRows] = useState<ItemClasseAuditoria[]>([]);
    const [totalElements, setTotalElements] = useState<number>(0);
    const [pageable, setPageable] = useState(new Pageable(0, 10, "classeAuditoria.auditoria.numero,DESC", 0));

    const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | DataTableValueArray | undefined>(undefined);

    const navigate = useNavigate();

    const { startLoading, stopLoading } = useLoadingContext();
    const { msgErro } = useToastContext();

    const [filters, setFilters] = useState<AuditoriaDashboardFilters>({ unidadeOrganizacional: null, setor: null, planos: null, dataGeracao: { inicio: '', fim: '' } });

    const [opcaoSelecionada, setOpcaoSelecionada] = useState<string>("pizza");

    const [unidades, setUnidades] = useState<UnidadeOrganizacional[]>([]);
    const [setores, setSetores] = useState<Setor[]>([]);
    const [planos, setPlanos] = useState<PlanoAuditoria[]>([]);

    const opcoes = [
        { label: "", value: "pizza", icon: "chart-pie", color: "#555" },
        { label: "", value: "barra", icon: "chart-simple", color: "#555" },
        { label: "", value: "tabela", icon: "table", color: "#555" }
    ]

    useEffect(() => {
        buscar();
        auditoriaService.unidadesOrgan().then(response => setUnidades(response)).catch(() => setPlanos([]));
    }, []);


    useEffect(() => {
        const unidadeFilter = filters.unidadeOrganizacional;
        auditoriaService.getSetoresDisponiveis(unidadeFilter || undefined).then(response => {
            setSetores(response)
        }).catch(() => console.error("Erro ao buscar setores disponíveis"));
    }, [filters.unidadeOrganizacional]);

    useEffect(() => {
        const setorFilter = filters.setor;
        auditoriaService.getPlanosDisponiveis(setorFilter || undefined).then(response => {
            setPlanos(response)
        }).catch(() => console.error("Erro ao buscar planos disponíveis"));

    }, [filters.setor]);

    useEffect(() => {
        if (filtrando) {

            auditoriaDashboardService
                .getAuditoriasNaoConformidade(pageable, filters)
                .then(lista => {

                    setFiltrando(false);
                    setRows(lista.content);
                    setTotalElements(lista.totalElements);
                })
                .catch(err => {
                    setFiltrando(false);
                });
        }
    }, [filtrando, pageable]);

    useEffect(() => {
        setFiltrando(true);
    }, [pageable]);

    const onPage = (event: DataTableStateEvent) => {

        setPageable({ ...pageable, page: event.page !== undefined ? event.page : 0, first: event.first });
        setFiltrando(true);

    };

    const rowExpansionTemplate = (item: ItemClasseAuditoria) => {
        return (
            <div className="p-3">
                <DataTable emptyMessage="Nenhuma distribuição encontrada" header="Ações" value={item.acoesAuditoria} dataKey="id">
                    <Column field="nome" header="Ação" ></Column>
                    <Column field="descricao" header="Descrição" ></Column>
                    <Column field="respsota" header="Resposta" ></Column>
                    <Column field="status" header="Status" body={rowData => auditoriaService.getStatusAcaoAuditoria(rowData.status)} ></Column>
                    <Column field="responsavel.nome" header="Responsável" ></Column>
                </DataTable>
            </div>
        );
    };

    function buscar() {
        setFiltrando(true);
        startLoading();
        auditoriaDashboardService.getGraficoNaoConformidadeBarras(filters).then(json => {
            stopLoading();
            setChartNaoConformidadeBarras(json);
        }).catch(err => {
            msgErro("Falha ao carregar gráfico de não conformidades", "");
            stopLoading();

            console.log(err);
        });

        auditoriaDashboardService.getGraficoNaoConformidadePizza(filters).then(json => {
            setChartNaoConformidadePizza(json);
        }).catch(err => {
            console.log(err);
        });
    }

    function getHeader() {
        return (
            <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                <div>Itens não conformes</div>
                <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Itens não conformes</span>
                <div >
                    <Button
                        type="button"
                        icon="pi pi-file-pdf"
                        onClick={() => gerarRelatorioListagem()}
                    />
                </div>


            </div>
        )
    }

    function gerarRelatorioListagem() {
        startLoading();
        auditoriaDashboardService.getRelatorioListagemNaoConformidade(filters).then(data => {
            stopLoading();
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, `Auditorias.pdf`);
        }).catch(err => {
            stopLoading();
            msgErro("Erro ao gerar Relatório", err.message);
            console.log(err);
        });
    }

    return (
        <div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <span style={{ fontSize: 18, fontWeight: 700, textAlign: "center", marginBottom: 12 }}>Dashboard - Auditorias</span>
                <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>

                    <DatePicker
                        slotProps={{
                            popper: {
                                disablePortal: true,
                            },
                        }}
                        value={filters.dataGeracao?.inicio ? dayjs(filters.dataGeracao.inicio) : null}
                        onChange={value => {
                            if (value?.toDate())
                                setFilters({ ...filters, dataGeracao: { ...filters.dataGeracao, inicio: value?.toDate() } })
                        }}
                    />

                    <label style={{ marginLeft: 8, marginRight: 8 }}>à</label>
                    <DatePicker
                        value={filters.dataGeracao?.fim ? dayjs(filters.dataGeracao.fim) : null}
                        onChange={value => {
                            if (value?.toDate())
                                setFilters({ ...filters, dataGeracao: { ...filters.dataGeracao, fim: value?.toDate() } })
                        }}
                    />
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <Label>Unidade organizacional</Label>
                    <Dropdown value={filters.unidadeOrganizacional} options={unidades}
                        style={{ width: 525, marginBottom: 12 }}
                        onChange={(e) => {
                            if (e.value == -1) e.value = null;
                            setFilters({ ...filters, unidadeOrganizacional: e.value })
                        }}
                        optionLabel={"nome"} optionValue={"id"} placeholder="Qualquer..." className="p-column-filter"
                        filter
                    />
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }} >
                    <Label>Setor</Label>
                    <Dropdown value={filters.setor} options={setores}
                        style={{ width: 525, marginBottom: 12 }}
                        onChange={(e) => {
                            if (e.value == -1) e.value = null;
                            setFilters({ ...filters, setor: e.value })
                        }}
                        optionLabel={"nome"} optionValue={"id"} placeholder="Qualquer..." className="p-column-filter"
                        filter
                    />
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <Label>Plano de auditoria</Label>
                    <MultiSelect
                        value={filters.planos} options={planos}
                        onChange={(e: MultiSelectChangeEvent) => setFilters({ ...filters, planos: e.value })}
                        optionLabel="nome" optionValue="id" placeholder="Qualquer..." className="p-column-filter"
                        style={{ width: 525, marginBottom: 12 }}
                        filter
                    />
                </div>
                <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
                    <Button label="Filtrar" icon="pi pi-filter" className="p-button-outlined" onClick={() => buscar()} />
                    <Button type="button" icon="pi pi-filter-slash" className="p-button-danger" label="Limpar" outlined onClick={() => setFilters({ setor: null, planos: null, dataGeracao: { inicio: '', fim: '' } })} style={{ marginLeft: 8 }} />
                </div>
            </div>
            <div style={{ width: "100%", alignItems: "center", marginBottom: 12 }}>

                <MultiSeletor
                    onChange={(value: string) => {
                        if (value) {
                            setOpcaoSelecionada(value)
                        }
                    }}
                    value={opcaoSelecionada}
                    width={200}
                    itemWidth={50}
                    options={opcoes}
                    iconSize="2x"
                    bgColor="#FFF"
                />
            </div>
            {opcaoSelecionada == "pizza" || opcaoSelecionada == "barra" ? <div style={{
                display: "flex",
                justifyContent: "center"
            }}>
                <div style={{
                    display: "flex",
                    width: "300px",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px 20px",
                    border: "1px solid #DDD",
                    borderRadius: 8, backgroundColor: "#FFF"
                }}>
                    <div style={{ display: "flex", alignItems: "center", columnGap: 10 }}>
                        <div style={{ minWidth: 20, minHeight: 20, backgroundColor: "#FF6384", borderRadius: 10 }}></div>
                        <span style={{ textOverflow: "ellipsis", overflow: "hidden" }}>Não conforme</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", columnGap: 10 }}>
                        <div style={{ minWidth: 20, minHeight: 20, backgroundColor: "#36A2EB", borderRadius: 10 }}></div>
                        <span style={{ textOverflow: "ellipsis", overflow: "hidden" }}>Conforme</span>
                    </div>
                </div>
            </div> : null}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                {opcaoSelecionada == "pizza" ? <AuditoriaNaoConformidadeChartPie
                    data={chartNaoConformidadePizza}
                /> : null}
                {opcaoSelecionada == "barra" ? <AuditoriaNaoConformidadeChartBar
                    data={chartNaoConformidadeBarras}
                /> : null}
                <DataTable
                    style={opcaoSelecionada == "tabela" ? {} : { display: "none" }}
                    header={getHeader()}
                    expandedRows={expandedRows} rowExpansionTemplate={rowExpansionTemplate}
                    onRowToggle={(e) => setExpandedRows(e.data)}
                    emptyMessage="Nenhum resultado encontrado"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                    currentPageReportTemplate="{first} - {last} de {totalRecords}"
                    value={rows} lazy dataKey="id" paginator
                    first={pageable.first} rows={10} totalRecords={totalElements} onPage={onPage}
                    loading={filtrando} tableStyle={{ minWidth: '75rem' }}
                >

                    <Column expander={(rowData) => rowData.acoesAuditoria.length > 0} style={{ width: '5rem' }} />
                    <Column field="classeAuditoria.auditoria.numero" header="Nr." style={{ minWidth: '55px' }}></Column>
                    <Column field="classeAuditoria.auditoria.nome" header="Plano" style={{ minWidth: '200px' }}></Column>
                    <Column field="classeAuditoria.auditoria.setor.nome" header="Setor" style={{ minWidth: '200px' }}></Column>
                    <Column field="nome" header="Item" style={{ minWidth: '25rem' }}></Column>
                    <Column body={(rowData) => {
                        return <SplitButton
                            model={[
                                {
                                    label: 'Simplificado', command: () => {
                                        startLoading();
                                        auditoriaService.getRelatorioSimplificado(rowData.classeAuditoria.auditoria.id).then(data => {
                                            stopLoading();
                                            const file = new Blob([data], { type: 'application/pdf' });
                                            saveAs(file, `(simpl.) Auditoria ${rowData.classeAuditoria.auditoria.setor.nome} - ${rowData.classeAuditoria.auditoria.mes} - ${rowData.classeAuditoria.auditoria.ano}.pdf`);
                                        }).catch(err => {
                                            stopLoading();
                                            msgErro("Erro ao gerar Relatório", err.message);
                                            console.log(err);
                                        });
                                    }
                                },
                                {
                                    label: 'Simplificado C/ Imagens', command: () => {
                                        startLoading();
                                        auditoriaService.getRelatorioSimplificadoComImagens(rowData.classeAuditoria.auditoria.id).then(data => {
                                            stopLoading();
                                            const file = new Blob([data], { type: 'application/pdf' });
                                            saveAs(file, `(simplCImg.) Auditoria ${rowData.classeAuditoria.auditoria.setor.nome} - ${rowData.classeAuditoria.auditoria.mes} - ${rowData.classeAuditoria.auditoria.ano}.pdf`);
                                        }).catch(err => {
                                            stopLoading();
                                            msgErro("Erro ao gerar Relatório", err.message);
                                            console.log(err);
                                        });
                                    }
                                },
                                {
                                    label: 'Resultado', command: () => {
                                        startLoading();
                                        auditoriaService.getRelatorioResultado(rowData.classeAuditoria.auditoria.id).then(data => {
                                            stopLoading();
                                            const file = new Blob([data], { type: 'application/pdf' });
                                            saveAs(file, `(Res.) Auditoria ${rowData.classeAuditoria.auditoria.setor.nome} - ${rowData.classeAuditoria.auditoria.mes} - ${rowData.classeAuditoria.auditoria.ano}.pdf`);
                                        }).catch(err => {
                                            stopLoading();
                                            msgErro("Erro ao gerar Relatório", err.message);
                                            console.log(err);
                                        });
                                    }
                                }
                            ]}
                            icon="pi pi-file-pdf"
                            onClick={() => {
                                startLoading();
                                auditoriaService.getRelatorio(rowData.classeAuditoria.auditoria.id).then(data => {
                                    const file = new Blob([data], { type: 'application/pdf' });
                                    saveAs(file, `Auditoria ${rowData.classeAuditoria.auditoria.setor.nome} - ${rowData.classeAuditoria.auditoria.mes} - ${rowData.classeAuditoria.auditoria.ano}.pdf`);
                                    stopLoading();
                                }).catch(err => {
                                    stopLoading();
                                    msgErro("Erro ao gerar Relatório", err.message);
                                    console.log(err);
                                });
                            }}
                        ></SplitButton>
                    }} />

                    <Column body={(rowData) => {
                        return <Button type="button" icon={<FontAwesomeIcon icon="eye" />} className="ui-button-info" onClick={() => navigate(`/auditoria/editar/${rowData.classeAuditoria.auditoria.id}`)}></Button>
                    }} />
                </DataTable>
            </div>
        </div>
    );
}